import React from 'react';
import { useModal } from 'react-modal-hook';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Button, Icon, Text } from 'components';
import { theme, toRem } from 'design';
import { selectCurrentEmployeeSite } from 'store/Employers';
import { PermissionType } from 'types';
import { hasSitePermission } from 'utils';
import { Title } from '../../../styles';
import { HealthReportModal } from './HealthReportModal';

const Layout = styled.div`
  flex-direction: column;
  align-items: flex-start;
  padding: ${toRem(theme.space.xl)};
  gap: ${toRem(theme.space.lg)};
  background: ${theme.color.primary[25]};
  border: ${toRem(1)} solid ${theme.color.primary[500]};
  border-radius: ${toRem(8)};
  align-self: stretch;
  flex-grow: 0;
  margin-top: ${toRem(theme.space.lg)};

  p {
    color: ${theme.color.neutral[600]};
  }
`;

const StyledButton = styled(Button)`
  width: ${toRem(200)} !important;
`;

const StyledIcon = styled(Icon)`
  position: relative;
  margin-right: ${toRem(theme.space.sm)};
  fill: ${theme.color.primary[600]};
  top: ${toRem(3)};
`;

export const GenerateHealthReport: React.FC = () => {
  const currentSite = useSelector(selectCurrentEmployeeSite);
  const generateHealthReportPermission = hasSitePermission(currentSite?.permissions, PermissionType.GENERATE_HEALTH_REPORT);
  const [showHealthReportModal, hideHealthReportModal] = useModal(() => <HealthReportModal siteId={currentSite.id} onClose={hideHealthReportModal} />, [currentSite]);

  // Do not display if user do not have permissions
  if (!generateHealthReportPermission) return <></>;

  return (
    <Layout data-cy="health-report">
      <Title fontWeight="medium">
        <StyledIcon icon="CustomDial" />
        Health Report
      </Title>
      <Text size="xsmall">Generate a POS Health Check to review data quality, key metrics, gratuities, sales, and potential issues like missing labor, missing owners, or auto clock-outs.</Text>
      <StyledButton appearance="primary" size="small" label="Generate Health Report" data-cy="health-report-button" onClick={showHealthReportModal} />
    </Layout>
  );
};
